import { Component , ViewChild } from '@angular/core';
import { NavController, NavParams, Slides, LoadingController } from 'ionic-angular';

import { ApiService } from '../../app/services/api.service';
import { Broadcaster } from '../../app/broadcaster';
import { Storage } from '@ionic/storage';
import { OkageStorageProvider } from '../../providers/okage-storage/okage-storage';

@Component({
  selector: 'page-favorites',
  templateUrl: 'favorites.html',
  providers: [ApiService]
})

export class FavoritesPage {

	@ViewChild('pageSlider') pageSlider: Slides;
	tabs: any = '0';

  items: Array<Array<{id: number, title: string, desc: string, thumb: string, price: number, like: number; liked: boolean, aIndex: number, iIndex: number}>>;
  iFoods: Array<Array<number>>;
  iTotal: number;
  loading: any;

  /**
   *
   * @param navCtrl
   * @param navParams
   * @param _apiService
   */
	constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private _apiService: ApiService,
              private storage: Storage,
              private _okageStorage: OkageStorageProvider,
              private broadcaster: Broadcaster,
              private loadingCtrl: LoadingController) {

    this.loading = this.loadingCtrl.create();
    this.iFoods = [];
    this.items = [];
    this.loading.present();
    this._apiService.getFavoriteList(1).subscribe(
      (result) => {
        this.loading.dismiss();
        if ( result.status == 1000 ) {
          for (var i = 0; i < result.content.length; i++) {
            if (!this.items[i]) {
              this.items[i] = [];
            }
            for (var j = 0; j < result.content[i].length; j++) {
              this.items[i][j] = {
                id: result.content[i][j].id,
                title: result.content[i][j].title,
                desc: result.content[i][j].desc,
                thumb: result.content[i][j].thumb,
                price: result.content[i][j].price,
                like: result.content[i][j].like,
                liked: result.content[i][j].liked,
                aIndex: -1,
                iIndex: -1
              };
            }
          }
          this.storage.get('foods.menu').then((m) => {
            for (var i = 0; i < m.length; i++) {
              for (var j = 0; j < m[i].length; j++) {
                for (var k = 0; k < this.items.length; k++) {
                  for (var t = 0; t < this.items[k].length; t++) {
                    if (this.items[k][t].id == m[i][j].id) {
                      this.items[k][t].aIndex = i;
                      this.items[k][t].iIndex = j;
                      break;
                    }
                  }
                }
              }
            }
            this.foodCounterChanged();
          });
        }

      },
      error => {
        console.log(error);
        this.loading.dismiss();
      });
    
    this.broadcaster.on<number>('foodCounterChanged')
      .subscribe(from => {
        if (from != 4) {
          this.foodCounterChanged();
        }
      });

    this.broadcaster.on<number>('foodLikeChanged')
      .subscribe(from => {
        if (from != 4) {
          this.foodLikeChanged();
        }
      });

      console.log(this.items);
  }

  foodCounterChanged() {
    this.iFoods = [];
    this.iTotal = 0;
    this.storage.get('foods.selected').then((v) => {
      if (v) {
        this.iFoods = v;
      }
      this.countTotal();
    });
  }

  foodLikeChanged() {
    this.storage.get('foods.menu').then((m) => {
      if (m) {
        for (var i = 0; i < m.length; i++) {
          for (var j = 0; j < m[i].length; j++) {
            for (var k = 0; k < this.items.length; k++) {
              for (var t = 0; t < this.items[k].length; t++) {
                if (this.items[k][t].id == m[i][j].id) {
                  this.items[k][t].like = m[i][j].like;
                  this.items[k][t].liked = m[i][j].liked;
                  break;
                }
              }
            }
          }
        }
      }
    });
  }

  chooseFood(aIndex, iIndex) {
    if (!this.iFoods[aIndex]) {
      this.iFoods[aIndex] = [];
    }
    if (!this.iFoods[aIndex][iIndex]) {
      this.iFoods[aIndex][iIndex] = 0;
    }
    this.iFoods[aIndex][iIndex]++;
    this.storage.set('foods.selected', this.iFoods).then((a) => {
      this.countTotal();
      this.broadcaster.broadcast('foodCounterChanged', 4);
    });
  }

  removeFood(aIndex, iIndex) {
    if (!this.iFoods[aIndex][iIndex]) {
      return;
    }
    this.iFoods[aIndex][iIndex]--;
    this.storage.set('foods.selected', this.iFoods).then((a) => {
      this.countTotal();
      this.broadcaster.broadcast('foodCounterChanged', 4);
    });
  }

  private countTotal() {
    var total = 0;
    for(var i = 0; i < 3; i++) {
      if (this.iFoods[i]) {
        for(var j = 0; j < this.iFoods[i].length; j++) {
          if (this.iFoods[i][j]) {
            total += this.iFoods[i][j];
          }
        }
      }
    }
    this.iTotal = total;
    this.storage.set('iTotal', this.iTotal);
  }

  like(i, j, aIndex, iIndex) {
    if (!this.items[i][j].liked) {
      this.items[i][j].liked = true;
      this.items[i][j].like++;
      this.storage.get('foods.menu').then((ms) => {
        if (ms) {
          ms[aIndex][iIndex].liked = this.items[i][j].liked;
          ms[aIndex][iIndex].like = this.items[i][j].like;
          
          this.storage.set('foods.menu', ms).then((a) => {
            this.broadcaster.broadcast('foodLikeChanged', 4);
            this._apiService.like(this.items[i][j].id).subscribe(
            (result) => {
              console.log(result);
            });
          });
        }
      });
    } else {
      this.items[i][j].liked = false;
      this.items[i][j].like--;
      this.storage.get('foods.menu').then((ms) => {
        if (ms) {
          ms[aIndex][iIndex].liked = this.items[i][j].liked;
          ms[aIndex][iIndex].like = this.items[i][j].like;
          
          this.storage.set('foods.menu', ms).then((a) => {
            this.broadcaster.broadcast('foodLikeChanged', 4);
            this._apiService.unlike(this.items[i][j].id).subscribe(
            (result) => {
              console.log(result);
            });
          });
        }
      });
    }
  }

	ionViewDidLoad() {
	}
	selectTab(index) {
		this.pageSlider.slideTo(index);
	}

	changeWillSlide($event) {
	 	this.tabs = $event._snapIndex.toString();
	}

  sendOrder() {
    this.navCtrl.parent.select(6);
  }
}



// WEBPACK FOOTER //
// ./src/pages/favorites/favorites.ts